import React, { useState } from "react";
import Moment from "moment";

import { Button, DetailModal, detailModalDismissButtonProps } from "../ui";

const EMPTY = () => ({ date: Moment().format("LLL"), description: "" });

const NoteModal = ({ addNote, showNotesModal, setShowNotesModal }) => {
    const [note, setNote] = useState(EMPTY);

    const handleClose = () => {
        setNote(EMPTY);
        setShowNotesModal(false);
    };

    const handleSubmit = () => {
        if (!note.description.trim()) return;
        addNote(note);
        setNote(EMPTY);
        setShowNotesModal(false);
    };

    return (
        <DetailModal
            open={showNotesModal}
            onClose={handleClose}
            title="Add Note"
            size="md"
            actions={
                <>
                    <Button {...detailModalDismissButtonProps} onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={handleSubmit}
                        disabled={!note.description.trim()}
                    >
                        Add Note
                    </Button>
                </>
            }
        >
            <textarea
                autoFocus
                rows={5}
                value={note.description}
                onChange={(e) => setNote({ ...note, description: e.target.value })}
                placeholder="Write your note here…"
                className="w-full resize-none rounded-lg border border-ink-200 px-3 py-2.5 text-sm text-ink-900 placeholder-ink-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
            />
        </DetailModal>
    );
};

export default NoteModal;
